import setupDeprecationWorkflow from "ember-cli-deprecation-workflow";
import DEPRECATION_WORKFLOW from "./deprecation-workflow";

setupDeprecationWorkflow({ workflow: DEPRECATION_WORKFLOW });
